import { SportId } from 'app/lib/betting/constants';

import { MatchNotStarted } from '../MatchNotStarted';
import { BasketballInformation } from './components/Basketball';
import { CounterStrikeInformation } from './components/CounterStrike';
import { DotaInformation } from './components/Dota';
import { ESportInformation } from './components/ESport';
import { HandballInformation } from './components/Handball';
import { IceHockeyInformation } from './components/IceHockey';
import { SoccerInformation } from './components/Soccer';
import { TableTennisInformation } from './components/TableTennis';
import { TennisInformation } from './components/Tennis';
import { VolleyballInformation } from './components/Volleyball';

// ---

export const getMatchInformationComponent = (sportId: SportId, isMatchNotStarted: boolean) => {
  if (isMatchNotStarted) {
    return MatchNotStarted;
  }

  switch (sportId) {
    case SportId.SOCCER: return SoccerInformation;
    case SportId.ICE_HOCKEY: return IceHockeyInformation;
    case SportId.BASKETBALL: return BasketballInformation;
    case SportId.TENNIS: return TennisInformation;
    case SportId.TABLE_TENNIS: return TableTennisInformation;
    case SportId.VOLLEYBALL: return VolleyballInformation;
    case SportId.E_SPORT: return ESportInformation;
    case SportId.HANDBALL: return HandballInformation;
    case SportId.DOTA: return DotaInformation;
    case SportId.CS_GO: return CounterStrikeInformation;

    default:
      console.warn('Unable to get <MatchInformation /> component by sport id', sportId);

      return () => null;
  }
};
